import { __rest } from "tslib";
import React, { forwardRef } from "react";
import { useWindowSize } from "../../../shared/hooks";
import * as S from "../styles";
export var Header = forwardRef(function (e, r) {
  var a = e.className,
      t = e.children,
      s = __rest(e, ["className", "children"]);

  var o = t.mobile,
      d = t.desktop,
      i = t.hidden,
      _useWindowSize = useWindowSize(),
      l = _useWindowSize.isMobile;

  return React.createElement(S.HeaderWrapper, Object.assign({
    className: a,
    ref: r
  }, s), React.createElement(S.Header, null, l ? o : d), React.createElement(S.HiddenWrapper, null, i));
});
export default Header;